import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import { useState } from 'react';



function App() {

  const [data, setData] = useState('')

  function getdata() {
    axios.get('https://twilight-haze-0f80.youxiang95278.workers.dev/').then(res => {
      console.log(res)
      setData(JSON.stringify(res.data))
    })
  }



  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <br />
        <button onClick={getdata}>请求works接口</button>
        <p>接口内容：{data}</p>
      </header>
    </div>
  );
}

export default App;
